import AppRoute from "models/AppRoute"

const RentToBuyChecklistRoute = new AppRoute({
    route: "/checklist-rent-to-buy",
    navbar: true,
    authRequired: true,
})

export default RentToBuyChecklistRoute
